import { __assign } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { useStyles } from './Listbox.styles';
export var Listbox = React.forwardRef(function (props, ref) {
    var classes = useStyles();
    return (React.createElement("ul", __assign({ ref: ref, role: "listbox" }, props, { 
        // Declare after spread to merge consumer styles with internal styles.
        className: clsx(classes.list, classes.listbox, props.className) }), props.children));
});
export default Listbox;
//# sourceMappingURL=Listbox.js.map